import { ShowToastUtil } from "../utilities/showToastUtil";
import ApiRequest from "../services/apiService";
import baseUrl from "../services/baseUrl";
import GetUserData from "../utilities/getUserDetails";

function encodeBase64(data) {
  if(data){
    return btoa(unescape(encodeURIComponent(data))); 
  }
  else{
    return null;
  }
}
// Function for user authentication
export default async function LoginCheck(userId, userPass, queryMode) {
  try {
    const url = `${baseUrl()}/Account/Login?email=${encodeURIComponent(
      encodeBase64(userId)
    )}&password=${encodeBase64(userPass)}&queryMode=${encodeBase64(queryMode)}`;
    const responseData = await ApiRequest({
      apiLink: url,
      method: "GET",
      getToken: "No",
    });
    if (responseData.Message === "Success") {
      const authUser = responseData.Data;
      return authUser;
    } else {
      return {
        UserId: "",
        UserCode: "",
        UserName: "",
        UserEmail: "",
        UserPassword: "",
        UserMobile: "",
        ProjectIds: "",
        ProjectName: "",
        UserRole: "",
        WarehouseCode: "",
        SourceOfBusiness: "",
        IsActive: "",
        IsLoggedIn: "",
        Designation: "",
        WorkLocation: "",
        OtpDateTime: "",
        LoginProvider: "",
        ProviderKey: "",
        PermissionList: "",
        PermissionAction: "",
        OTPCounter: "",
        IsWrongPasswordAttempt: "",
        ValidationKey: "",
        ResponseMessage: "",
      };
    }
  } catch (error) {
    console.error("Error during login:", error);
    ShowToastUtil(
      "An error occurred during login. Please try again later.",
      "error"
    );
    return null;
  }
}
